import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/apiClient';
import { Wallet, PlusCircle, Store } from 'lucide-react';
import '../company.css';

const fmt = (n) => new Intl.NumberFormat('fa-IR').format(Number(n) || 0);

export default function CompanyWallet() {
    const [wallets, setWallets] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        setLoading(true);
        try {
            const [walletRes, vendorRes] = await Promise.all([
                apiClient.GET('/api/v1/company/wallet'),
                apiClient.GET('/api/v1/company/contracts/vendors') // گرفتن لیست فروشندگان برای نمایش موجودی
            ]);
            if (walletRes.data) setWallets(walletRes.data);
            if (vendorRes.data) setVendors(vendorRes.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleIncreaseBalance = () => {
        alert('درگاه شارژ حساب متصل نیست');
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '3rem' }}>در حال دریافت اطلاعات...</div>;

    return (
        <div className="company-wallet" style={{ direction: 'rtl', display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%' }}>

            {/* هدر صفحه: عنوان در راست، دکمه در چپ */}
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '1rem' }}>
                <h1 style={{ fontSize: '1.5rem', color: '#1e293b', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem', whiteSpace: 'nowrap' }}>
                    <Wallet size={24} color="#2563eb" /> کیف پول و اعتبار شرکت
                </h1>

                <button
                    onClick={handleIncreaseBalance}
                    style={{
                        background: '#10b981', color: '#fff', border: 'none', padding: '0.6rem 1.2rem',
                        borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem',
                        display: 'flex', alignItems: 'center', gap: '0.5rem', boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)'
                    }}
                >
                    <PlusCircle size={18} /> افزایش اعتبار
                </button>
            </header>

            {/* گرید کارت‌های موجودی (جمع‌وجورتر) */}
            <div className="company-wallet-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1.2rem', width: '100%' }}>
                {vendors.length === 0 ? (
                    <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '3rem', background: '#fff', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
                        فروشنده‌ای برای نمایش موجودی یافت نشد.
                    </div>
                ) : vendors.map(v => {
                    const wallet = wallets.find(w => w.vendor_id === v.id);
                    const balance = wallet ? Number(wallet.balance) : 0;

                    return (
                        <div key={v.id} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', padding: '1.2rem', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>

                            {/* نام فروشگاه */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.2rem' }}>
                                <div style={{ background: '#eff6ff', padding: '0.5rem', borderRadius: '50%' }}><Store size={20} color="#2563eb" /></div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '1rem', color: '#1e293b' }}>{v.name}</h3>
                                    <span style={{ fontSize: '0.75rem', color: '#64748b' }}>فروشگاه تامین‌کننده</span>
                                </div>
                            </div>

                            {/* موجودی */}
                            <div style={{ background: '#f8fafc', padding: '0.85rem', borderRadius: '8px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
                                <p style={{ margin: '0 0 0.4rem 0', color: '#475569', fontSize: '0.8rem' }}>موجودی نزد فروشنده:</p>
                                <strong style={{ fontSize: '1.2rem', color: balance > 0 ? '#10b981' : '#ef4444' }}>
                                    {fmt(balance)} ریال
                                </strong>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}